import React from 'react'
import $ from 'jquery';
import '../css/validations.css'

const EMAIL_FORMAT = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
const CARDCODE_FORMAT = /^[a-zA-Z0-9\_\-]{4,16}$/;
let noSuggest = false
const SendMailModal = (props) => {
    const { MailTools, SendEmail, ShowExtraActions, suggestedEmail, type } = props;

    function RefreshModel(sendMailModel) {
        MailTools.RefreshSendMailModel(sendMailModel);
    }

    function ChangeMailTo(value) {
        let mails = value.split(' ');
        let withOutSpace="";
        noSuggest=true
        for (let index = 0; index < mails.length; index++) {
            withOutSpace = withOutSpace + mails[index].trim()
        }
        MailTools.sendMailModel.to = withOutSpace;
        RefreshModel(MailTools.sendMailModel);
    }

    function ChangeSubject(value) {
        MailTools.sendMailModel.subject = value;
        RefreshModel(MailTools.sendMailModel);
    }

    function ChangeMailCC(value) {
        let mails = value.split(' ');
        let withOutSpace="";
        for (let index = 0; index < mails.length; index++) {
            withOutSpace = withOutSpace + mails[index].trim()
        }
        MailTools.sendMailModel.cc = withOutSpace;
        RefreshModel(MailTools.sendMailModel);
    }

    function ChangeMailMessage(value) {
        MailTools.sendMailModel.message = value;
        RefreshModel(MailTools.sendMailModel);
    }

    function ChangeSendFile() {
        MailTools.sendMailModel.sendFile = !MailTools.sendMailModel.sendFile;
        RefreshModel(MailTools.sendMailModel);
    }

    function ChangeSendXML() {
        MailTools.sendMailModel.sendXML = !MailTools.sendMailModel.sendXML;
        RefreshModel(MailTools.sendMailModel);
    }

    function CloseModal() {
        noSuggest=false
        $('#pdfSendMailModal').modal('hide');
        MailTools.sendMailModel = {
            to: '',
            cc: '',
            subject: '',
            message: '',
            docEntry: null,
        }
        RefreshModel(MailTools.sendMailModel);
        ResetValidations()
    }

    function ValidateE_mail() {
        let element = document.getElementById('inputEmail');
        let text = document.querySelector(`#grupo__inputEmail .form__input-error`);
        let require = document.querySelector(`#grupo__inputEmail .form__input-void`);
        let mails = MailTools.sendMailModel.to.trim().split(';');
        
        for (let index = 0; index < mails.length; index++) {
            if (!MailTools.sendMailModel.to == '') {
                if (!EMAIL_FORMAT.test(mails[index].trim())) {
                    element.classList.add('form__group-incorrect');
                    element.classList.remove("form__group-correct");
                    text.classList.add('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    return (false)
                } else {
                    element.classList.remove('form__group-incorrect');
                    element.classList.add("form__group-correct");
                    text.classList.remove('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    return (true)
                }
            } else {
                element.classList.add("form__group-incorrect");
                text.classList.remove('form__input-error-active');
                require.classList.add('form__input-void-active');
                return (false)
            }
        }

    }

    function ValidateCC() {
        let element = document.getElementById('ccEmail');
        let text = document.querySelector(`#grupo__ccEmail .form__input-error`);
        let mails = (MailTools.sendMailModel.cc || "").trim().split(';');

        for (let index = 0; index < mails.length; index++) {
            if (!MailTools.sendMailModel.cc == '') {
                if (!EMAIL_FORMAT.test(mails[index].trim())) {
                    element.classList.add('form__group-incorrect');
                    element.classList.remove("form__group-correct");
                    text.classList.add('form__input-error-active');
                    return (false)
                } else {
                    element.classList.remove('form__group-incorrect');
                    element.classList.add("form__group-correct");
                    text.classList.remove('form__input-error-active');
                    return (true)
                }
            } else {
                element.classList.remove("form__group-incorrect");
                text.classList.remove('form__input-error-active');
                return (true)
            }
        }
    }

    function ValidateSubject() {
        let require = document.querySelector(`#grupo__subject .form__input-void`);

        if (!MailTools.sendMailModel.subject == '') {
            if (!CARDCODE_FORMAT.test(MailTools.sendMailModel.subject)) {
                require.classList.remove('form__input-void-active');
            } else {
                require.classList.remove('form__input-void-active');
            }
        } else {
            require.classList.add('form__input-void-active');
        }
    }

    async function ValidateMessage() {
        // let text= document.querySelector(`#grupo__bodyMail .form__input-error`);
        let require = document.querySelector(`#grupo__bodyMail .form__input-void`);

        if (!MailTools.sendMailModel.message == '') {
            if (!CARDCODE_FORMAT.test(MailTools.sendMailModel.message)) {
                // text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
            } else {
                // text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        } else {
            require.classList.add('form__input-void-active');
            // text.classList.remove('form__input-error-active');
        }
    }

    async function ValidateAll() {
        ValidateE_mail()
        ValidateCC()
        ValidateSubject()
        ValidateMessage()

    }

    async function ValidateDataMail() {
        ChangeMailTo(!!MailTools ? (MailTools.sendMailModel.to || suggestedEmail || '') : "")
        ValidateAll();
        if (ValidateCC() == true && ValidateE_mail() == true) {
            SendEmail()
            ResetValidations()
            CloseModal()
        }

        // $('#newClientModal').modal('hide');
        // $('#vmNewClient').modal('show');
    }

    async function ResetValidations() {
        const ids = [
            'inputEmail',
            'ccEmail',
            'subject',
            'bodyMail',
        ];
        for (let index = 0; index < ids.length; index++) {
            let element = document.getElementById(ids[index]);
            let text = document.querySelector(`#grupo__` + ids[index] + ` .form__input-error`);
            let require = document.querySelector(`#grupo__` + ids[index] + ` .form__input-void`);
            element.classList.remove("form__group-correct");
            element.classList.remove('form__group-incorrect');
            $(text).removeClass("form__input-error-active");
            $(require).removeClass("form__input-void-active");
        }
    }

    async function ResetModal() {
        // const {clearData} = this.props;
        await ResetValidations();
        // await clearData();
    }

    return (
        <>
            <div className="modal custom fade" id="pdfSendMailModal" tabindex="-1" role="dialog" aria-labelledby="trackModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content" style={{ boxShadow: "1px 1px 5px rgb(0 0 0 / 30%)" }}>
                        <div className="modal-header" style={{ background: "#f9f9f9" }}>
                            {/* <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> */}
                        </div>

                        <div className="modal-body" style={{ minHeight: "130px", background: "#f9f9f9" }}>
                            <form>
                                <div className="form-group formulario__grupo" id="grupo__inputEmail">
                                    <div className="form-group input-group form__group-input">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">Para:</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control form__input "
                                            id="inputEmail"
                                            onChange={(event) => ChangeMailTo(event.target.value)}
                                            value={MailTools && (MailTools.sendMailModel.to || (noSuggest? "":suggestedEmail ) || '')}
                                            placeholder="Correo electrónico"
                                            onBlur={ValidateE_mail}
                                        />
                                    </div>
                                    <p className="form__input-error" style={{ marginTop: "-15px", marginLeft: "60px" }}>Ingrese una dirección de correo electronico valido.</p>
                                    <p className="form__input-void" style={{ marginTop: "-15px", marginLeft: "60px" }}>El correo no puede ir vacio.</p>
                                </div>
                                <div className="form-group formulario__grupo" id="grupo__ccEmail">
                                    <div className="form-group input-group form__group-input">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">CC:</span>
                                        </div>
                                        <input type="text"
                                            className="form-control form__input"
                                            id="ccEmail"
                                            onChange={(event) => ChangeMailCC(event.target.value)}
                                            value={MailTools && (MailTools.sendMailModel.cc || '')}
                                            placeholder="Con copia a..."
                                            onBlur={ValidateCC}
                                        />
                                    </div>
                                    <p className="form__input-error" style={{ marginTop: "-15px", marginLeft: "50px" }}>Ingrese una dirección de correo electrónico valido.</p>
                                </div>
                                <div className="form-group formulario__grupo" id="grupo__subject">
                                    <div className="form-group input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">Asunto:</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control form__input"
                                            id="subject"
                                            onChange={(event) => ChangeSubject(event.target.value)}
                                            value={MailTools && (MailTools.sendMailModel.subject || '')}
                                            onBlur={ValidateSubject}
                                        />
                                    </div>
                                    <p className="form__input-void" style={{ marginTop: "-15px", marginLeft: "82px", color: "#6c757d" }}>Va a enviar el correo sin asunto.</p>
                                </div>
                                <div className="form-group formulario__grupo" id="grupo__bodyMail">
                                    <div className="form-group mt-4">
                                        {/* <label for="exampleFormControlTextarea1">Mensaje:</label> */}
                                        <textarea
                                            className="form-control form__input"
                                            id="bodyMail"
                                            rows="3"
                                            placeholder="Mensaje"
                                            style={{ minHeight: "180px" }}
                                            onChange={(event) => ChangeMailMessage(event.target.value)}
                                            value={MailTools && (MailTools.sendMailModel.message || '')}
                                            onBlur={ValidateMessage}
                                        />
                                    </div>
                                    <p className="form__input-void" style={{ marginTop: "-15px", marginLeft: "4px", color: "#6c757d" }}>Va a enviar el correo sin mensaje.</p>
                                </div>
                                {!!ShowExtraActions && ShowExtraActions &&
                                    <>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className="form-group formulario__grupo" id="grupo__subject">
                                                    <div className="form-group input-group">
                                                        <div className="input-group-prepend mr-2">
                                                            <span className="input-group-text">Adjuntar documento:</span>
                                                        </div>
                                                        <input
                                                            type="checkbox"
                                                            className="form-control form__input"
                                                            checked={MailTools && (MailTools.sendMailModel.sendFile)}
                                                            onChange={() => ChangeSendFile()}

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='col-md-2'></div> */}
                                            {type !== "ODPI" &&
                                                <div className='col-md-5'>
                                                    <div className="form-group formulario__grupo" id="grupo__subject">
                                                        <div className="form-group input-group">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">Enviar xml:</span>
                                                            </div>
                                                            <input
                                                                type="checkbox"
                                                                className="form-control form__input"
                                                                checked={MailTools && (MailTools.sendMailModel.sendXML)}
                                                                onChange={() => ChangeSendXML()}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </>
                                }
                            </form>
                        </div>

                        <div className="modal-footer" style={{ background: "#f9f9f9" }}>
                            <button type="button" className="btn btn-secondary" onClick={() => CloseModal()}>Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => ValidateDataMail()} >Enviar
                                <i className="fa fa-paper-plane ml-2"></i>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SendMailModal